module.exports = __webpack_public_path__ + "static/img/art-c.f6d101aa.png";